import Vue from 'vue';
import vuexI18n from 'vuex-i18n';
import App from './App.vue';
import router from './router';
import languages from './assets/i18n';
import { Lang } from './utils/index.model';
import store from './store';
import './utils/directives.ts';
import './assets/css/index.scss';
import VueFullscreen from 'vue-fullscreen';
import Clipboard from 'v-clipboard';
import '@/utils/adapter-7.4.0';
// import 'adapterjs';
// @ts-ignore
import vClickOutside from 'v-click-outside';
import VConsole from 'vconsole';
import { AntiInspectLayer } from './utils/anti-inspect';
import { installToastPlugin } from './plugins/toast';

Vue.config.productionTip = false;
Vue.use(vClickOutside);
Vue.use(Clipboard);
Vue.use(vuexI18n.plugin, store);
Vue.use(VueFullscreen);
installToastPlugin();

/*
 * Lock page zoom on mobile. `touch-action: manipulation` (index.scss) stops
 * double-tap zoom but still allows pinch, and iOS ignores `user-scalable=0`,
 * so pinch is blocked here: `gesturestart` is Safari's pinch event, and a
 * two-finger `touchmove` covers the rest. Listeners must be non-passive for
 * preventDefault to take effect.
 */
document.addEventListener('gesturestart', (e) => e.preventDefault(), { passive: false });
document.addEventListener(
  'touchmove',
  (e) => {
    if (e.touches.length > 1) e.preventDefault();
  },
  { passive: false }
);

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('debug') === 'true' && process.env.NODE_ENV !== 'production') {
  new VConsole();
}
Vue.i18n.add(Lang.en, languages['en']);
Vue.i18n.add(Lang.zh, languages['zh']);
Vue.i18n.add(Lang.vn, languages['vn']);
Vue.i18n.add(Lang.id, languages['id']);
Vue.i18n.add(Lang.th, languages['th']);
Vue.i18n.add(Lang.es, languages['es']);
Vue.i18n.add(Lang.pk, languages['pk']);
Vue.i18n.add(Lang.jp, languages['jp']);
Vue.i18n.add(Lang.kr, languages['kr']);
Vue.i18n.add(Lang.mm, languages['mm']);
Vue.i18n.add(Lang.bd, languages['bd']);
Vue.i18n.add(Lang.in, languages['in']);
Vue.i18n.add(Lang.hant, languages['hant']);
Vue.i18n.add(Lang.kh, languages['kh']);
Vue.i18n.add(Lang.pt, languages['pt']);
Vue.i18n.add(Lang.uz, languages['uz']);
// Anti-inspect protection - add ?debug=true to URL to disable
export const antiInspect = new AntiInspectLayer({
  enabled: true,
  redirectUrl: 'about:blank',
});

// Set up metrics logging callback for anti-inspect events
antiInspect.setMetricsLogCallback((type: number) => {
  console.log('[AntiInspect] Metrics callback triggered with type:', type);
  store.dispatch('general/sendMetricsLog', type);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
